const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const codeGeneration = require('../codeGeneration');

let setupCode = '';
let loopCode = '';
let defineCode = '';
let bodycode = '';
let codeContext = 'setup';
const definedFunctions = new Set();
const definedServos = new Set(); // Keep track of defined servos
const menuIconURI = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAmVBMVEX///84frj/wzH/wir/0Ggye7dsnMgcc7MkdrQreLX/wSL/wBr/vxD/wi3/4KIwerakwNv//fj4+/1ChLv/03T/7s3/ylD/6Lt3o8vN3Ou2zOLe6PJVjsCuxd3/5rT/46uXttWKrtFomcb/9N3/xj7/3JL/1Xr/0Wz/14XB0+b/9+f/+/H/68N9p83S3+3/2oz/zV7u9PlSi79Hq+jtAAAHiUlEQVR4nO2caXPaTAyAg43xzX2YK+EM0NCk9P//uBcafEAAy1oZGV49XzptZ5h9Ztd7Snp5EQRBEARBEARBEARBEARBEAQBzG7Y34zrk+nvIKhUKkHwezqpjzf94Y67Yeo0h5tJpWWapmXZtl2rGd/Uavu/WZZlmq1gMhg2uZuJpT8Z1UzLNkq3MGzLNEaTPndjM7MbzFLlTjVng0cas/0AbhdZWlblUXpy89fMqneUNFsD7sYD6LcsnN93R7aK3o/NANl/cT8GhZ5aP42akt+BmvHJrXGdgansd8As7Nc4TgruF3V0f5pjbpXLbBKCVmlar0/3fyAVN9wyl9jFgkbp2MJNCznvmEVc/keRjDGKpsPmCLk0jjhVLpMco4n5vonrwyKO03g8WieN2+C+RaPFJXKNYaILT/8H24lDHpGr1O2wabXp6f9McYuGXecRuUpQu9a02D0TtYBH5CqV6DMkMjQqPCJXiQ2JRmmBDYlmGmPGI3KVhCHJalFoQ5IVv9iGBLu2ghsmdt4l9Im/2IbKp6cHMFQ7Af8zLNrp4oehKmJ4d8RQDMWQH3rDv9xKZzy/4cw2YDys4XRWgTF6VEMwA+ClxuMajsXwf2NYEsPCAjYs3MMFFOhcymE4rAfANY9iPYwMv8o/aFfnOfhtWqZdS9+ykO1pIsOyo//A8RY9Yr/dSDFOJjuRoa5dwHe7vygFN3f3SzPUNN0j7MYxTZwMraGmeW9UgkSBQOSGmvdKI/jJIggx1LwOhWDz/p8g2NDXGwSGgXowXm6GmrNSF+zzjFGgIcU4xcZt3cnQX6gKYp9w72WouaqrIlsXQg1VO5HtKwQbqn6J5Neg9Ia60nS6Y/sK4Yaa+6FgOHgIQ5W924xvkMIN9bKCId88E99EpRpqHl6wzzhIDbihi59NJ7iwQhrD8P3wT6qhs0QbogOaKAzD+NKun2bod7GCTaZTxT9qk2Mr0vwOnYg9Qw05J5owwrHhpht62MtFztUwyinpAAzRu2/WiSacSt8cwCjFTjWMm9KSFSZ3pS8W+zW/jTRs8QmWrGOIKuQzxJ+gGCcae3JswxZiiN3V7BgNjTDKGDJI94a44wXjYmGG+c6/PIig5uKWC75dqTUJ29AGdSF2Z8p2CWVFOSlzWBdiF0TwezQxZtSDgD3pNw7ujQaZsKSIbcQ1B6qgifRgWEUZMmxpDDtaJl7gYxS9qUGmZB3bmpWabVvmaJBIt/lwgGN0b7hGGf5GGhq2ZbVG0Ei+kGAy/jypF/GxgM2jB/R3lGGA2ZYeirCcNRVHFkHsxhRhWDNnG5rCHXM9gyD2Vjjz0cIwA6r05KoH/gbvaGiNqPzmXegyERrirkwzGppUyde/2l6WEarQh5m+Q4OoqkxjW87sdxdDo0VQqqPReSu7bnY/9FyaYT08E9w39av9M+DuJn+6mus6GD0NvR5m2NMYCcHGa9dznQvhdilkmjzPQO5p4PtSM/4GG0vHVWkr0hC3LwWfLax4Ft06gMu/HAxxZwtwVH2cg7UEnwaIDXHnQ+gZP66zss64UJOBPOMD72niIiRLLkHsPQ3wri3qwi3TENXQd22w+9Iob76BXMsoQN6Xwu68ozofS5ZZ9GiIE4S9W1hhFzIKot8tIBvTqFDOK9s0o/D2BNnU2OErGPRqMw/Q74eQN2DruGFr8E2kCm/AkOUifOeDPEbnBvodHxLDHsZmQR6jcwMfz54eTxPtSb84p1J0PA1gqonWe+AzWC4oxESl70yjxQL2VpsPCnFt6buaQhgqxCamx5cWwVApvjR1RSyCoVKMcGqcdyEMVeK8U++9C2CoFqufmm9RAEPVzKeUnBl+Q+XEp5TrKH5D5bynlE5kN1TPXUv5EtkNKfJkb+aQchs62NN9kptnKGZDHx3DfsKtXG5mQ5pc7pv5+LyGVPn4t2oqsBrS1VS4UReD0ZC0Lsb12iZshtS1TV6u1aexw1sMsKGf+fn7AjnUpzlwqcbQLAznhRr63VXGEIYL5FNjKAWooUM2/d0bsCHh/HdfxFAMi48YRoZPP5fC18MvbqUzyPc0jspNdh6Q70uV7urzQAzFUAz5EUMxfHZD3fmRh/BMhr6rravVtXYa4/9Ehrq2/f6JrZb8jecx1LvR00Ojm/iRpzH0tcTbSkOLB+rTGLrb5K8k6nw8jaF2+jPxvz+LoX6WkrWOfuZZDM8TlqpREGfhDJHRlzcMKd6vKaniImivj1JkOlp+wGtYnHH6M/G/o2O3c2OBy0a4tloQxMlQ08MF619b8dVDnejpIteLi7s2HR+cnh/AolU/FS/tvD3qJ2wSekjFC6cn2iAEOt7QmUFnJ2DKMBJaXrNVJLmCTxcIRE9HV0+dcXSiUK58aLQVu9H3ViTBeDnSWSjUVPDdRaE78Ehvgai/ckDPJw4oDzqr7EVYdNddPUL/hXz0yp4LrrfmO65XflVKDGGhs/zj7DVvlmXx9b2c3l0+Uu+d0Jj3lu2F53mu6ziJmjWHv7iu63mL9rI3L/rkCeBj3um9VZfr9/ZqVV6t2u/rZfWt15k/3rgUBEEQBEEQBEEQBEEQBEEQBEb+A8jcyJvuhgJ3AAAAAElFTkSuQmCC"

class PythonRobo_arm {
    constructor(runtime) {
        this.runtime = runtime;
    }

    getInfo() {
        return {
            id: "pythonRoboArm", // Unique ID for the extension
            name: "Python Robo Arm", // Display name in the Scratch menu
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: 'calibrate',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.calibrate',
                        default: 'calibrate_servos ( )',
                        description: 'Move all servos to their calibrated positions.'
                    }),
                    func: 'calibrate'
                },
                {
                    opcode: 'setInitialPosition',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.setInitialPosition',
                        default: 'set_init_pos ( )',
                        description: 'Set the initial positions for all servos.'
                    }),
                    func: 'setInitialPosition'
                },
                {
                    opcode: 'manualControl',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.manualControl',
                        default: 'control_arm_manually( )',
                        description: 'Control the arm manually.'
                    }),
                    func: 'manualControl'
                },
                {
                    opcode: 'setServo',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.setServo',
                        default: 'set_servo (pos = [base], pin = [pinNo])',
                        description: 'Attach a servo to the specified pin based on the base selected.'
                    }),
                    arguments: {
                        base: {
                            type: ArgumentType.STRING,
                            menu: 'baseMenu',
                            defaultValue: 'base'
                        },
                        pinNo: {
                            type: ArgumentType.STRING,
                            menu: 'pinMenu',
                            defaultValue: '2'
                        }
                    },
                    func: 'setServo'
                },
                {
                    opcode: 'moveBase',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveBase',
                        default: 'move_base (angle = [angle], speed = [speed])',
                        description: 'Move the base servo to the specified angle with the given speed.'
                    }),
                    arguments: {
                        angle: {
                            type: "angle",
                            defaultValue: 90
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 15
                        }
                    },
                    func: 'moveBase'
                },
                {
                    opcode: 'moveShoulder',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveShoulder',
                        default: 'move_shoulder (angle = [angle], speed = [speed])',
                        description: 'Move the shoulder servo to the specified angle with the given speed.'
                    }),
                    arguments: {
                        angle: {
                            type: "angle",
                            defaultValue: 90
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 15
                        }
                    },
                    func: 'moveShoulder'
                },
                {
                    opcode: 'moveElbow',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveElbow',
                        default: 'move_elbow (angle = [angle], speed = [speed])',
                        description: 'Move the elbow servo to the specified angle with the given speed.'
                    }),
                    arguments: {
                        angle: {
                            type: "angle",
                            defaultValue: 90
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 15
                        }
                    },
                    func: 'moveElbow'
                },
                {
                    opcode: 'moveWrist1',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveWrist1',
                        default: 'move_wrist1 (angle = [angle], speed = [speed])',
                        description: 'Move the wrist1 servo to the specified angle with the given speed.'
                    }),
                    arguments: {
                        angle: {
                            type: "angle",
                            defaultValue: 90
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 15
                        }
                    },
                    func: 'moveWrist1'
                },
                {
                    opcode: 'moveWrist2',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveWrist2',
                        default: 'move_wrist2 (angle = [angle], speed = [speed])',
                        description: 'Move the wrist2 servo to the specified angle with the given speed.'
                    }),
                    arguments: {
                        angle: {
                            type: "angle",
                            defaultValue: 90
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 15
                        }
                    },
                    func: 'moveWrist2'
                },
                {
                    opcode: 'moveGrip',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveGrip',
                        default: 'move_grip(angle = [angle], speed = [speed])',
                        description: 'Move the grip servo to the specified angle with the given speed.'
                    }),
                    arguments: {
                        angle: {
                            type: "angle",
                            defaultValue: 60
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 15
                        }
                    },
                    func: 'moveGrip'
                },
                {
                    opcode: 'homePosition',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.homePosition',
                        default: 'move_to_home_pos ( )',
                        description: 'Move all servos to their home positions.'
                    }),
                    func: 'homePosition'
                },
                {
                    opcode: 'drawShape',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.drawShape',
                        default: 'draw_shape(shape = [shape])',
                        description: 'Draw a circle with the given radius.'
                    }),
                    arguments: {
                        shape: {
                            type: ArgumentType.STRING,
                            defaultValue: 'circle',
                            menu: 'shapeMenu'
                        },
                    },
                    func: 'drawShape'
                },
                {
                    opcode: 'moveToPose',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboArm.moveToPose',
                        default: 'move_pose(pose = [pose])',
                        description: 'Move to the are to given pose'
                    }),
                    arguments: {
                        pose: {
                            type: ArgumentType.STRING,
                            defaultValue: 'up',
                            menu: 'poseMenu'
                        },
                    },
                    func: 'moveToPose'
                },
            ],
            menus: {
                headerMenu: {
                  items: ['Wire.h', 'Adafruit_PWMServoDriver.h', 'Servo.h']
                },
                baseMenu: {
                  items: ['base', 'shoulder', 'elbow', 'wrist1', 'wrist2', 'grip']
                },
                pinMenu: {
                  items: ['2', '3', '4', '5', '6', '7']
                },
                channelMenu: {
                  items: ['0', '1', '2', '3', '4', '5']
                },
                contextMenu: {
                  items: ['setup', 'loop']
                },
                shapeMenu: {
                  items: ['circle', 'triangle']
                },
                poseMenu: {
                  items: ['up', 'down', 'pick', 'place']
                }
              }
            };
    }
    resetCode() {
        // Reset all accumulated code and status
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodycode = '';
    }
    full_reset() {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodycode = '';
        definedServos.clear(); // Clear the set of defined servos
        definedFunctions.clear();
        console.log('Arm Code has been reset.');
    }

    accumulateCode() {
        codeGeneration.accumulateCode(defineCode, bodycode, setupCode, loopCode);
    }
    setServo(args) {
        const base = args.base;
        const channelNo = args.channelNo;
        // Add the servo variable initialization to the setup code if not already present
        if (!definedServos.has(base)) {
            defineCode += `int ${base} = ${channelNo};\n`;
            definedServos.add(base);
        }

        this.accumulateCode();
        this.resetCode();
    }

    manualControl() {
        if (typeof window.sendPoseCommand === 'function') {
            window.sendPoseCommand("manual");
        }
    }

    moveBase(args) {
        const servoVar = 'servo_b';
        const MIN_ANGLE = 0;    // Define your minimum angle
        const MAX_ANGLE = 180;
        const angle = args.angle;
        const speed = args.speed;
        if (angle < MIN_ANGLE || angle > MAX_ANGLE) {
            // console.error;
            return (`Enter the angle between ${MIN_ANGLE} and ${MAX_ANGLE}`); // Exit the function if the angle is out of range
        }
        if (typeof window.moveArmJoint === 'function') {
            window.moveArmJoint('arm', angle);
        }
        // Generate the moveServo_b function
        if (!definedFunctions.has('moveServo_b')) {
            bodycode += `
              void moveServo_b(int endAngle, int delayTime) {
                 if (base_pos < endAngle) {
        for (int angle = base_pos; angle <= endAngle; angle++) {
          pwm.setPWM(base, 0, angleToPulse(angle));
          delay(delayTime);
        }
      } else {
        for (int angle = base_pos; angle >= endAngle; angle--) {
          pwm.setPWM(base, 0, angleToPulse(angle));
          delay(delayTime);
        }
      }
      // Update the current position
      base_pos = endAngle;
              }
            `;
            definedFunctions.add('moveServo_b');
        }

        const codeToAdd = `moveServo_b(${angle}, ${speed});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    moveShoulder(args) {
        const servoVar = 'servo_s';
        const MIN_ANGLE = 0;    // Define your minimum angle
        const MAX_ANGLE = 180;
        const angle = args.angle;
        const speed = args.speed;
        if (angle < MIN_ANGLE || angle > MAX_ANGLE) {
            // console.error;
            return (`Enter the angle between ${MIN_ANGLE} and ${MAX_ANGLE}`); // Exit the function if the angle is out of range
        }
        if (typeof window.moveArmJoint === 'function') {
            window.moveArmJoint('shoulder', angle);
        }
        // Generate the moveServo_s function
        if (!definedFunctions.has('moveServo_s')) {
            bodycode += `
              void moveServo_s(int endAngle, int delayTime) {
                 if (shoulder_pos < endAngle) {
        for (int angle = shoulder_pos; angle <= endAngle; angle++) {
          pwm.setPWM(shoulder, 0, angleToPulse(angle));
          delay(delayTime);
        }
      } else {
        for (int angle = shoulder_pos; angle >= endAngle; angle--) {
          pwm.setPWM(shoulder, 0, angleToPulse(angle));
          delay(delayTime);
        }
      }
      // Update the current position
      shoulder_pos = endAngle;
              }
            `;
            definedFunctions.add('moveServo_s');
        }
        const codeToAdd = `moveServo_s(${angle}, ${speed});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    moveElbow(args) {
        const MIN_ANGLE = 0;    // Define your minimum angle
        const MAX_ANGLE = 180;
        const angle = args.angle;
        const speed = args.speed;
        if (angle < MIN_ANGLE || angle > MAX_ANGLE) {
            // console.error;
            return (`Enter the angle between ${MIN_ANGLE} and ${MAX_ANGLE}`); // Exit the function if the angle is out of range
        }
        if (typeof window.moveArmJoint === 'function') {
            window.moveArmJoint('elbow', angle);
        }
        if (!definedFunctions.has('moveServo_e')) {
            bodycode += `
            void moveServo_e(int endAngle, int delayTime) {
           if (elbow_pos < endAngle) {
        for (int angle = elbow_pos; angle <= endAngle; angle++) {
          pwm.setPWM(elbow, 0, angleToPulse(angle));
          delay(delayTime);
        }
      } else {
        for (int angle = elbow_pos; angle >= endAngle; angle--) {
          pwm.setPWM(elbow, 0, angleToPulse(angle));
          delay(delayTime);
        }
      }
      // Update the current position
      elbow_pos = endAngle;
            }
          `;
            definedFunctions.add('moveServo_e');
        }
        const codeToAdd = `moveServo_e(${angle}, ${speed});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    moveWrist1(args) {
        const MIN_ANGLE = 0;    // Define your minimum angle
        const MAX_ANGLE = 180;
        const angle = args.angle;
        const speed = args.speed;
        if (angle < MIN_ANGLE || angle > MAX_ANGLE) {
            // console.error;
            return (`Enter the angle between ${MIN_ANGLE} and ${MAX_ANGLE}`); // Exit the function if the angle is out of range
        }
        if (typeof window.moveArmJoint === 'function') {
            window.moveArmJoint('wrist1', angle);
        }
        if (!definedFunctions.has('moveServo_w1')) {
            bodycode += `        
            void moveServo_w1(int endAngle, int delayTime) {
              if (wrist1_pos < endAngle) {
        for (int angle = wrist1_pos; angle <= endAngle; angle++) {
          pwm.setPWM(wrist1, 0, angleToPulse(angle));
          delay(delayTime);
        }
      } else {
        for (int angle = wrist1_pos; angle >= endAngle; angle--) {
          pwm.setPWM(wrist1, 0, angleToPulse(angle));
          delay(delayTime);
        }
      }
      // Update the current position
      wrist1_pos = endAngle;
            }
          `;
            definedFunctions.add('moveServo_w1');
        }
        const codeToAdd = `moveServo_w1(${angle}, ${speed});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    moveWrist2(args) {
        const MIN_ANGLE = 0;    // Define your minimum angle
        const MAX_ANGLE = 180;
        const angle = args.angle;
        const speed = args.speed;
        if (angle < MIN_ANGLE || angle > MAX_ANGLE) {
            // console.error;
            return (`Enter the angle between ${MIN_ANGLE} and ${MAX_ANGLE}`); // Exit the function if the angle is out of range
        }
        if (typeof window.moveArmJoint === 'function') {
            window.moveArmJoint('wrist2', angle);
        }
        if (!definedFunctions.has('moveServo_w2')) {
            bodycode += `
            void moveServo_w2(int endAngle, int delayTime) {
              if (wrist2_pos < endAngle) {
        for (int angle = wrist2_pos; angle <= endAngle; angle++) {
          pwm.setPWM(wrist2, 0, angleToPulse(angle));
          delay(delayTime);
        }
      } else {
        for (int angle = wrist2_pos; angle >= endAngle; angle--) {
          pwm.setPWM(wrist2, 0, angleToPulse(angle));
          delay(delayTime);
        }
      }
      // Update the current position
      wrist2_pos = endAngle;
            }
          `;
            definedFunctions.add('moveServo_w2');
        }
        const codeToAdd = `moveServo_w2(${angle}, ${speed});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    moveGrip(args) {
        const MIN_ANGLE = 60;    // Define your minimum angle
        const MAX_ANGLE = 120;  // Define your maximum angle
        const angle = args.angle;
        const speed = args.speed;

        // Check if the angle is within the valid range
        if (angle < MIN_ANGLE || angle > MAX_ANGLE) {
            // console.error;
            return (`Enter the angle between ${MIN_ANGLE} and ${MAX_ANGLE}`); // Exit the function if the angle is out of range
        }
        if (typeof window.moveArmJoint === 'function') {
            window.moveArmJoint('grip1', angle);
        }
        if (!definedFunctions.has('moveServo_grp')) {
            bodycode += `        
          void moveServo_grp(int endAngle, int delayTime) {
             if (grip_pos < endAngle) {
        for (int angle = grip_pos; angle <= endAngle; angle++) {
          pwm.setPWM(grip, 0, angleToPulse_grp(angle));
          delay(delayTime);
        }
      } else {
        for (int angle = grip_pos; angle >= endAngle; angle--) {
          pwm.setPWM(grip, 0, angleToPulse_grp(angle));
          delay(delayTime);
        }
      }
      // Update the current position
      grip_pos = endAngle;
          }
        `;
            definedFunctions.add('moveServo_grp');
        }
        const codeToAdd = `moveServo_grp(${angle}, ${speed});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    homePosition() {
        bodycode += `
            void home_pos() {
                ${definedServos.has('base') ? 'pwm.setPWM(base, 0, angleToPulse(base_pos));' : ''}
                ${definedServos.has('shoulder') ? 'pwm.setPWM(shoulder, 0, angleToPulse(shoulder_pos));' : ''}
                ${definedServos.has('elbow') ? 'pwm.setPWM(elbow, 0, angleToPulse(elbow_pos));' : ''}
                ${definedServos.has('wrist1') ? 'pwm.setPWM(wrist1, 0, angleToPulse(wrist1_pos));' : ''}
                ${definedServos.has('wrist2') ? 'pwm.setPWM(wrist2, 0, angleToPulse(wrist2_pos));' : ''}
                ${definedServos.has('grip') ? 'pwm.setPWM(grip, 0, angleToPulse(grip_pos));' : ''}
            }
        `;
        if (typeof window.sendPoseCommand === 'function') {
            window.sendPoseCommand("rest");
        }
        const codeToAdd = `
        home_pos();
        `;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }

    setInitialPosition() {
        // Define the initial positions if not already defined
        if (!definedServos.has('initial_positions')) {
            defineCode += `
                #define SERVOMIN_puls 170
    #define SERVOMAX_puls 600
    #define SERVOMIN_angle 5
    #define SERVOMAX_angle 180
    
    #define SERVOMIN_grp_angle 93
    #define SERVOMAX_grp_angle 160
    #define SERVOMIN_grp_puls 310
    #define SERVOMAX_grp_puls 533
    
    int base_pos = 90;
    int shoulder_pos = 90;
    int elbow_pos = 90;
    int wrist1_pos = 90;
    int wrist2_pos = 90;
    int grip_pos = 60;
    
    uint16_t angleToPulse(int angle) {
      return map(angle, SERVOMIN_angle, SERVOMAX_angle, SERVOMIN_puls, SERVOMAX_puls);
    }
    
    uint16_t angleToPulse_grp(int angle) {
      return map(angle, SERVOMIN_grp_angle, SERVOMAX_grp_angle, SERVOMIN_grp_puls, SERVOMAX_grp_puls);
    }
              `;
            definedServos.add('initial_positions');  // Track that initial positions are defined
        }
        this.accumulateCode();
        this.resetCode();
    }
    calibrate() {
        // Check each servo and calibrate it if detected
        bodycode += `
            void calibrate_() {
                ${definedServos.has('base') ? ' pwm.setPWM(base, 0, angleToPulse(90));' : ''}
                ${definedServos.has('shoulder') ? 'pwm.setPWM(shoulder, 0, angleToPulse(90));' : ''}
                ${definedServos.has('elbow') ? ' pwm.setPWM(elbow, 0, angleToPulse(90));' : ''}
                ${definedServos.has('wrist1') ? ' pwm.setPWM(wrist1, 0, angleToPulse(90));' : ''}
                ${definedServos.has('wrist2') ? 'pwm.setPWM(wrist2, 0, angleToPulse(90));' : ''}
                ${definedServos.has('grip') ? 'pwm.setPWM(grip, 0, angleToPulse(90));' : ''}
            }
        `;
        setupCode += `
            calibrate_();
        `;
        this.accumulateCode();
        this.resetCode();
    }
    drawShape(args) {
        const shape = args.shape;
        if (typeof window.sendPoseCommand === 'function') {
            window.sendPoseCommand(shape);
        }
    }
    moveToPose(args) {
        const pose = args.pose;
        if (typeof window.sendPoseCommand === 'function') {
            window.sendPoseCommand(pose);
        }
    }
}

module.exports = PythonRobo_arm;